import { render, staticRenderFns } from "./BiometryView.vue?vue&type=template&id=0148e01c"
import script from "./BiometryView.vue?vue&type=script&lang=js"
export * from "./BiometryView.vue?vue&type=script&lang=js"
import style0 from "./BiometryView.vue?vue&type=style&index=0&id=0148e01c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports